import React from 'react'
import BackToUp from '@uiw/react-back-to-top';
import Banner from '../components/organic9/banner/Banner'
import ShopNow from '../components/organic9/shop_now/ShopNow'
import TrendingRoducts from '../components/organic9/trending_roducts/TrendingRoducts'
import HealthyLive from '../components/organic9/healthy_live/HealthyLive'
import FlashDeal from '../components/organic9/flash_deal/FlashDeal'
import TopRatting from '../components/organic9/top_ratting/TopRatting'
import HealthyKitchen from '../components/organic9/healthy_kitchen/HealthyKitchen'
import Discover from '../components/organic9/discover/Discover'
import Feedback from '../components/organic9/feedback/Feedback'
import RecentNews from '../components/organic9/recent_news/RecentNews'
const Desktop9 = () => {
  return (
    <>
    <Banner/>
    <ShopNow/>
    <TrendingRoducts/>
    <HealthyLive/>
    <FlashDeal/>
    <TopRatting/>
    <HealthyKitchen/>
    <Discover/>
    <Feedback/>
    <RecentNews/>
    <div className="container">
      <BackToUp><i class="fa-solid fa-arrow-up"></i></BackToUp>
    </div>
    </>
  )
}

export default Desktop9
